export const calculateNewSelection = (
  currentSelected: Set<number>,
  itemId: number,
  multiSelect: boolean
): Set<number> => {
  if (multiSelect) {
    const newSelected = new Set(currentSelected);
    if (newSelected.has(itemId)) {
      newSelected.delete(itemId);
    } else {
      newSelected.add(itemId);
    }
    return newSelected;
  } else {
    if (currentSelected.size === 1 && currentSelected.has(itemId)) {
      return new Set();
    }
    return new Set([itemId]);
  }
};
